export enum PwaThemePropertyTypeEnum {
	COLOR = 'color',
}
